import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ProfileStore {

}

export enum ProfileStoreKeys {

}
